import { all } from 'redux-saga/effects'

import CreateProducer from './create/Saga'
import UpdateProducer from './update/Saga'
import ReadProducers  from './read/Saga'
import DeleteProducer from './delete/Saga'

export default function* rootSaga() {
  yield all([
    CreateProducer(),
		UpdateProducer(),
		ReadProducers(),
		DeleteProducer()
  ])
}